import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { formatDateTime } from "../../common-data/Converts";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import Modal from "react-modal";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import { isChannelIncluded } from "../Validations";
import { CheckCircleIcon, XCircleIcon } from "../../../images/icons/icons";
import BroadcastLogsListings from "./BroadcastLogsListings";

const BroadcastTemplateListings = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  userInfoData,
}) => {
  const { broadcastLogs, broadcastLogsLoading, broadcastLogsError } =
    useSelector((state) => state.blog);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
    templateBody: "",
    channelName: "",
    isSentSuccess: false,
    isSentFailed: false,
  };
  const [modValues, setModValues] = useState(iniModValues);

  const iniPTDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  useEffect(() => {
    if (
      !broadcastLogsLoading &&
      !broadcastLogsError &&
      broadcastLogs?.status &&
      broadcastLogs?.data?.length > 0
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: broadcastLogs.data,
        pagination:
          broadcastLogs?.pagination?.length > 0 ? broadcastLogs.pagination : [],
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [broadcastLogs, broadcastLogsLoading, broadcastLogsError]);

  const tbColumns = [
    {
      dataField: "whatsapp_account",
      text: "wati account",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.whatsapp_account?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "name",
      text: "broadcast name",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.name?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "channel",
      text: "whatsapp",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon minWidth100">
            {isChannelIncluded(row?.channel, "whatsapp") ? (
              <>
                <CheckCircleIcon />

                <br />

                <small
                  className="lowercase link"
                  onClick={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      modName: "description",
                      rowData: row,
                      templateBody: row?.template_whatsapp_body,
                      channelName: "whatsapp",
                    }))
                  }
                >
                  {row?.template_name_whatsapp || "NA"}
                </small>
              </>
            ) : (
              <XCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "channel",
      text: "push",
      formatter: (_, row) => {
        return (
          <span className="tb-data icon minWidth100">
            {isChannelIncluded(row?.channel, "push") ? (
              <>
                <CheckCircleIcon />

                <br />

                <small
                  className="lowercase link"
                  onClick={() =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      modName: "description",
                      rowData: row,
                      templateBody: row?.body_push,
                      channelName: "push",
                    }))
                  }
                >
                  {row?.template_name_push || "NA"}
                </small>
              </>
            ) : (
              <XCircleIcon />
            )}
          </span>
        );
      },
    },
    {
      dataField: "user_type",
      text: "user type",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.user_type || "NA"}</span>;
      },
    },
    {
      dataField: "total_users",
      text: "sent count",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "logs",
                rowData: row,
              }))
            }
          >
            {row?.total_users || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "sent_count",
      text: "sent success",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "logs",
                rowData: row,
                isSentSuccess: true,
              }))
            }
          >
            {row?.sent_count || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "failed_count",
      text: "sent failed",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data link"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                modName: "logs",
                rowData: row,
                isSentFailed: true,
              }))
            }
          >
            {row?.failed_count || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Detail Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "logs" ? "mod-width-70p" : "mod-width-50p"
          }`}
        >
          <ModalHeadAndClose
            title={
              modValues.modName === "description"
                ? modValues.rowData?.name?.replace(/_/g, " ") +
                  " " +
                  modValues.channelName
                : modValues.modName === "logs"
                ? modValues.rowData?.name?.replace(/_/g, " ")
                : modValues.modName?.replace(/_/g, " ")
            }
            onClose={onCloseModal}
          />

          {modValues.modName === "description" ? (
            <div className="discussionModalMessage mt30">
              <p
                className="message"
                dangerouslySetInnerHTML={{
                  __html: modValues.templateBody || "No Content Available",
                }}
              ></p>
            </div>
          ) : modValues.modName === "logs" ? (
            <BroadcastLogsListings
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              isSentSuccess={modValues.isSentSuccess}
              isSentFailed={modValues.isSentFailed}
            />
          ) : null}
        </div>
      </Modal>

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt15">
        {broadcastLogsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>
    </>
  );
};

export default BroadcastTemplateListings;
